import styles from "./assets/css/Terms.module.css";
import useFetch from "../../Hooks/useFetch";

const Terms = () => {
  const { data } = useFetch("pages/410");
  document.body.style = "background-color: #fff";
  return (
    <section className={styles.termsSection}>
      {data && (
        <>
          <h1 dangerouslySetInnerHTML={{ __html: data.title.rendered }}></h1>
          <div
            dangerouslySetInnerHTML={{
              __html: data.content.rendered,
            }}
          ></div>
        </>
      )}
    </section>
  );
};
export default Terms;
